import { AnimationFunction } from '@opten/animation/animation-function';
import { linearTween } from '@opten/animation/linear-tween';
import { scrollToOffset } from '../scroll-to-offset';

export function scrollToElement(
	target: Element,
	animation: AnimationFunction = linearTween,
	duration = 300,
	offset = 0,
	wrapper: HTMLElement | Window = window
) {
	const top =
		wrapper !== window
			? (target as HTMLElement).offsetTop - (wrapper as HTMLElement).scrollTop
			: target.getBoundingClientRect().top;

	return scrollToOffset(top, animation, duration, offset, wrapper);
}
